import React from 'react';
import clsx from "clsx";

export default class RatePresenterProducts extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'products',
      'tab-pane': true
    })

    var self = this;
    var products = this.props.products.map((product) => {
    var rate_product = self.getRateProduct(product)
      return (
        <div key={product.id}>
        <div className="row guest-type" key={product.id}>
          <div className="col-md-3 name-wrapper">
            <div className="form-group">
              <label>{I18n.t('product')}</label>
              <div>{product.name}</div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>{I18n.t('quantity')}</label>
              <div>{rate_product.quantity}</div>
            </div>
          </div>
        </div>
          {this.props.products.length > 1  ? <hr /> : null}
        </div>
      )
    })

    return(
      <div className={tabClasses} id="products">
          <div className="panel panel-default" style={{ marginBottom: 0 }}>
            <div className="panel-heading">
            <h3 className="panel-title pull-left">{I18n.t('products_included_with_the_rate')}<span className="ss-help help" title={I18n.t('rate_products_helper_text')}></span></h3>
              <div className="clearfix"></div>
            </div>
            <div className="panel-body">
              <div className={"products "}>
                {products && products.length ? products : <div className="no-records"><span className="none">{I18n.t('none')}</span></div>}
              </div>
            </div>
          </div>
      </div>
    )
  }

  getRateProduct(product) {
    if (this.props.rate_products && this.props.rate_products.length) {
      for (var i = 0, ilen = this.props.rate_products.length; i < ilen; i++) {
        if (this.props.rate_products[i].product_id == product.id) {
          return this.props.rate_products[i];
        }
      }
    }

    return null
  }
}
